module.exports = __webpack_public_path__ + "img/add-tag.788cb5ad.svg";